import { render, staticRenderFns } from "./SongBlockProfile.vue?vue&type=template&id=26b04914&scoped=true"
import script from "./SongBlockProfile.vue?vue&type=script&lang=js"
export * from "./SongBlockProfile.vue?vue&type=script&lang=js"
import style0 from "./SongBlockProfile.vue?vue&type=style&index=0&id=26b04914&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26b04914",
  null
  
)

export default component.exports